import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigNewsWidgetComponent } from './uig-news-widget/uig-news-widget.component';
import { UigNewsFeedComponent } from './uig-news-feed/uig-news-feed.component';
import { CmsConfig, ConfigModule, I18nConfig, I18nModule, OccConfig, provideConfig } from '@spartacus/core';
import { UigNewsAdapter } from './uig-news.adapter';
import { UigPipesModule } from 'src/app/pipes/uig-pipes.module';

@NgModule({
  declarations: [UigNewsWidgetComponent, UigNewsFeedComponent],
  imports: [
    CommonModule,
    UigPipesModule,
    ConfigModule.withConfig(<CmsConfig | OccConfig>{
      cmsComponents: {
        NewsFeedComponent: {
          component: UigNewsFeedComponent
        },
        NewsWidgetComponent2: {
          component: UigNewsWidgetComponent
        }
      },
      backend: {
        occ: {
          endpoints: {
            customGetNews: 'news/get'
          },
        },
      },
    }),
    I18nModule,
  ],
  providers: [
    {
      provide: UigNewsAdapter,
      useClass: UigNewsAdapter,
    },
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: { uigNews: ['uigNews'] },
      },
    })
  ]
})
export class UigNewsModule { }
